import {
	// LocalAuthorityChapterAccount,
	// Observation,
	Service,
	Scenario,
	ServiceGroup,
	SituationRecord
} from "../../model"
// import {
// 	getObservationFromLaca,
// 	getOperationExpenseObservations,
// } from "./observation-domain"
import {
	// getScenarizedAccountFromLaca,
	// getScenarizedChapterFromLaca,
	getScenarizedServices,
	// getScenarizedYear,
	// getScenarizedYearAccount,
	// weightObservationWithAccount,
	// weightObservationWithChapter,
	// weightObservationWithYearAccount,
} from "./scenario-domain"
import { IconProp } from "@fortawesome/fontawesome-svg-core"

export const HIGH_CONSUMPTION_PERCENTAGE = 0.1
export const LOW_CONSUMPTION_PERCENTAGE = 0

export enum LevelOfConsumption {
	High,
	Low,
	Medium
}

/**
 * Filtre les enregistrements passés en paramètre en fonction du service passé
 * en paramètre.
 *
 * Si le paramètre optionnel `aggregate` est `true`, les enregistrements sont
 * aggrégés selon leur libellé.
 *
 * @param records
 * @param service
 * @param aggregate
 */
export function filterRecordsByService(
	records: SituationRecord[],
	service: Service,
	aggregate = false
): SituationRecord[] {
	if (!aggregate) return records.filter(r => r.service === service.id)

	let data = [];
	records.map((record) => {
		if (record.service !== service.id) return true
		const index = data.findIndex(r => r.label === record.label)
		if (index >= 0) {
			data[index].engaged += record.engaged
			data[index].liquidated += record.liquidated
			data[index].planned += record.planned
		} else data.push({...record})
	})
	return data
	// return records.reduce<SituationRecord[]>((aggregated, record) => {
	// 	if (record.service !== service.id) return aggregated

	// 	const alreadyAdded = aggregated.find(r => r.label === record.label)

	// 	if (alreadyAdded) {
	// 		alreadyAdded.engaged += record.engaged
	// 		alreadyAdded.liquidated += record.liquidated
	// 		alreadyAdded.planned += record.planned
	// 	} else aggregated.push(record)

	// 	return aggregated
	// }, [])
}

/**
 * Filtre les enregistrements passés en paramètre en fonction du groupe de
 * services passé en paramètre.
 * @param records
 * @param serviceGroup
 */
export function filterRecordsByServiceGroup(
	records: SituationRecord[],
	serviceGroup: ServiceGroup
): SituationRecord[] {
	return records
	.filter(r => serviceGroup.services.some(s => s === r.service))
}

export function findBudgetEvolution(
	budgetEvolutions: ServiceBudgetEvolution[],
	service: Service
): ServiceBudgetEvolution|null {
	return budgetEvolutions.find(b => b.id === service.id) || null
}

export function getAbsoluteConsumption(
	totalExpense: number,
	repository: number
): number {
	return totalExpense - repository
}

/**
 * Retourne le budget annuel du service spécifié pour le scénario spécifié.
 * @param scenario
 * @param service
 */
export function getAnnualBudget(
	service: Service,
	scenario: Scenario
): number {
		const scenarizedServices = getScenarizedServices(scenario, service)
		return scenarizedServices.reduce((sum, sat) => {
			return sat.receipts ? sum : sum + sat.amount
		}, 0)
}

export function getAvailableBudget(annualBudget: number, totalExpense: number): number {
	return annualBudget - totalExpense
}

export function getAvailableBudgetTotal(liquidated: number, engaged: number,planned: number): number {
	return planned - (engaged + liquidated)
}

export function getGlobalAnnualBudget(servicesBudgetEvolution: ServiceBudgetEvolution[]): number {
	return servicesBudgetEvolution.reduce(
		(reduced, sbe) => reduced + sbe.annualBudget
	, 0)
}

export function getGlobalEngaged(
	servicesBudgetEvolution: ServiceBudgetEvolution[]
): number {
	return servicesBudgetEvolution.reduce(
		(reduced, sat) => reduced + sat.engaged
	, 0)
}

export function getGlobalLiquidated(
	servicesBudgetEvolution: ServiceBudgetEvolution[]
): number {
	return servicesBudgetEvolution.reduce(
		(reduced, sat) => reduced + sat.liquidated
	, 0)
}

export function getGlobalPlanning(
	servicesBudgetEvolution: ServiceBudgetEvolution[]
): number {
	return servicesBudgetEvolution.reduce(
		(reduced, sat) => reduced + sat.planned
	, 0)
}

export function getGlobalPlanned(
	servicesBudgetEvolution: ServiceBudgetEvolution[]
): number {
	return servicesBudgetEvolution.reduce(
		(reduced, sat) => reduced + sat.plannedConsumption
	, 0)
}

export function getGlobalTotalExpense(
	servicesBudgetEvolution: ServiceBudgetEvolution[]
): number {
	return servicesBudgetEvolution.reduce(
		(reduced, sat) => reduced + sat.totalExpense
	, 0)
}


export function getPercentageConsumption(
	totalExpense: number,
	repository: number
): number {
	if (!repository) return 0
	return (totalExpense / repository) - 1
}

export function getRepository(
	annualBudget: number,
	planned: number,
	dayOfYear: number,
	daysInYear: number
): number {
	if (!(planned && daysInYear)) return 0
	return annualBudget * dayOfYear / daysInYear * planned
}

export function getTotalExpense(engaged: number, liquidated: number): number {
	return engaged + liquidated
}

export function getLevelOfConsumption(consumptionPercentage: number): LevelOfConsumption {
	if (consumptionPercentage > HIGH_CONSUMPTION_PERCENTAGE)
		return LevelOfConsumption.High

	if (consumptionPercentage >= LOW_CONSUMPTION_PERCENTAGE
	&& consumptionPercentage <= HIGH_CONSUMPTION_PERCENTAGE)
		return LevelOfConsumption.Medium

	if (consumptionPercentage < LOW_CONSUMPTION_PERCENTAGE)
		return LevelOfConsumption.Low
}

export function getLevelOfConsumptionIcon(level: LevelOfConsumption): Icon {
	switch (level) {
		case LevelOfConsumption.High:
			return {
				color: "#FF0000",
				name: "frown"
			}
		case LevelOfConsumption.Low:
			return {
				color: "#32CD32",
				name: "smile"
			}
		default:
			return {
				color: "#FFA500",
				name: "meh"
			}
	}
}

export function isGlobalBudgetEvolution(
	budgetEvolution: BudgetEvolution
): budgetEvolution is GlobalBudgetEvolution {
	return undefined !== (budgetEvolution as GlobalBudgetEvolution).isGlobal
}

export function isServiceBudgetEvolution(
	budgetEvolution: BudgetEvolution
): budgetEvolution is ServiceBudgetEvolution {
	return !isServiceGroupBudgetEvolution(budgetEvolution)
	&& !isGlobalBudgetEvolution(budgetEvolution)
}

export function isServiceGroupBudgetEvolution(
	budgetEvolution: BudgetEvolution
): budgetEvolution is ServiceGroupBudgetEvolution {
	return undefined !== (budgetEvolution as ServiceGroupBudgetEvolution).services
}

/**
 * Sommes les budgets des enregistrements passés en paramètre.
 * @param records
 */
export function sumBudgets(records: SituationRecord[]): Budgets {
	const initial: Budgets = { engaged: 0, liquidated: 0, planned: 0, available:0 }
	return records.reduce((budgets, record) => {
		budgets.engaged += record.engaged || 0
		budgets.liquidated += record.liquidated || 0
		budgets.planned += record.planned || 0
		budgets.available += (record.planned - (record.engaged + record.liquidated))
		return budgets
	}, initial)
}

export interface BaseBudgetEvolution {
	annualBudget: number
	availableBudget: number
	consumption: Consumption
	engaged: number
	label: string
	levelOfConsumption: LevelOfConsumption
	liquidated: number
	plannedConsumption: number
	repository: number
	slug: string
	totalExpense: number
	available: number
	planned: number
}

export interface Budgets {
	engaged: number;
	liquidated: number;
	planned: number;
	available: number
}

export interface Consumption {
	absolute: number
	percentage: number
}

export interface GlobalBudgetEvolution extends BaseBudgetEvolution {
	isGlobal: true
}

export interface Icon {
	name: IconProp
	color: string
}

export interface ServiceGroupBudgetEvolution
extends BaseBudgetEvolution, ServiceGroup {
	serviceBudgets: ServiceBudgetEvolution[]
}

export type BudgetEvolution = GlobalBudgetEvolution
| ServiceBudgetEvolution
| ServiceGroupBudgetEvolution

export type ServiceBudgetEvolution = BaseBudgetEvolution & Service

// /**
//  * Retourne le budget annuel global du scénario spécifié.
//  * @param lacas
//  * @param observations
//  * @param scenario
//  */
// export function foo(
// 	lacas: LocalAuthorityChapterAccount[],
// 	observations: Observation[],
// 	scenario: Scenario,
// 	service?: Service
// ): number {
// 	/** Budget annuel */
// 	let annualBudget = 0
// 	/** Constats de dépense de fonctionnement de l'année précédant le scénario. */
// 	const prevYearExpenseObs = getOperationExpenseObservations(observations, scenario.year - 1)

// 	// pour chaque compte d'une collectivité locale
// 	lacas.forEach(laca => {
// 		/** Constat de dépense de fonctionnement lié au laca */
// 		const observation = getObservationFromLaca(laca, prevYearExpenseObs)
// 		/** Chapitre scénarizé lié au laca */
// 		const scenarizedChapter = getScenarizedChapterFromLaca(laca, scenario)

// 		// si le chapitre scénarisé existe bien
// 		if (scenarizedChapter) {
// 			// pondération du constat et ajout au budget annuel
// 			annualBudget += weightObservationWithChapter(observation, scenarizedChapter)
// 			// passage au laca suivant
// 			return
// 		}

// 		/** Compte scénarisé lié au laca */
// 		const scenarizedAccount = getScenarizedAccountFromLaca(laca, scenario)

// 		// si le compte scénarisé existe bien
// 		if (scenarizedAccount) {
// 			// pondération du constat et ajout au budget annuel
// 			annualBudget += weightObservationWithAccount(observation, scenarizedAccount)
// 			// passage au laca suivant
// 			return
// 		}

// 		/** Année scénarisée correspondant à l'année spécifiée en paramètre */
// 		const scenarizedYear = getScenarizedYear(scenario, scenario.year)

// 		// si l'année scénarisée existe bien
// 		if (scenarizedYear) {
// 			/** Compte de l'année scénarisée lié au laca */
// 			const scenarizedYearAccount = getScenarizedYearAccount(laca, scenarizedYear)
// 			annualBudget += weightObservationWithYearAccount(observation, scenarizedYearAccount)
// 			// passage au laca suivant
// 			return
// 		}

// 		annualBudget += observation ? observation.amount : 0
// 	})

// 	return annualBudget
// }



// WEBPACK FOOTER //
// ./src/domain/sfp/counter-domain.ts